import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={`mb-14 ${align === "center" ? "text-center" : ""}`}>
    <p className="eyebrow mb-4">{eyebrow}</p>
    <h2 className="font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
    {sub && <p className="mt-5 max-w-2xl text-sm font-light leading-relaxed text-[#B5B0A8] sm:text-base">{sub}</p>}
  </Reveal>
);
